import { NextFetch } from '@/utils/request';
import host from '@/utils/request/host';

interface Params {
  name?: string;
  mobile?: string;
  shopId?: number;
  smsCode?: string;
  smsToken?: string;
}

export async function fetchClueRegisterApi(params?: Params) {
  return await NextFetch.post<any>(`${host.crm}/h5/shopWebsite/clueRegister`, params);
}

interface VerifySMS {
  remainSecond: number;
  smsToken: string;
}

export async function verifyCodeApi(phone?: string) {
  return await NextFetch.get<VerifySMS>(`${host.sms}/code`, { phone });
}
